import React from 'react';
import { FormHelperText } from '@mui/material';
import { IError } from './helixIcons';

export default function FormControlError({ message }: { message: string }) {
  return (
    <FormHelperText
      style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}
    >
      <IError style={{ marginRight: 4 }} />
      {message}
    </FormHelperText>
  );
}
